
export const mainMenu = ["Главная", "О приложении", "Контакты"]

export const hamburgerMenu = [...mainMenu, "Войти"]